import { Avatar } from "@mui/material";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import React from "react";

const AvatarOrIcon = ({ srcPath, classImg }: any) => {
  if (srcPath) return <Avatar src={srcPath} className={classImg} />;

  return <AccountCircleOutlinedIcon className={classImg} />;
};

export default AvatarOrIcon;
